import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import 'vuetify/src/styles/main.sass'
import pt from 'vuetify/es5/locale/pt'
import { lightTheme, darkTheme } from '@/themes/defaultThemes'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    themes: {
      light: lightTheme,
      dark: darkTheme,
    },
    icons: {
      iconfont: 'fa',
    },
    options: {
      customProperties: true,
      minifyTheme: function (css) {
        return css.replace(/[\r\n|\r|\n]/g, '')
      },
    },
  },
  lang: {
    locales: { pt },
    current: 'pt',
  },
})
